export const canOpenSetupWizardOnRoute = (routeName: null | string | symbol | undefined): boolean =>
	routeName !== 'login' && routeName !== 'versionMismatch';

export type SetupWizardVisibilityContext = {
	deferredInSession: boolean;
	deviceSupportsAutoOpen: boolean;
	loggedIn: boolean;
	preferencesLoaded: boolean;
	routeName: null | string | symbol | undefined;
};

export type SetupWizardVisibilityAction = 'close' | 'idle' | 'openIfNeeded';

/**
 * Resolves what should happen to the global setup wizard for a given app state.
 *
 * `close` is reserved for public auth routes, where no modal may stay on screen.
 * Unsupported devices and a deferred wizard both resolve to `idle`, so a manually
 * opened wizard survives navigation.
 */
export const resolveSetupWizardVisibilityAction = ({
	deferredInSession,
	deviceSupportsAutoOpen,
	loggedIn,
	preferencesLoaded,
	routeName,
}: SetupWizardVisibilityContext): SetupWizardVisibilityAction => {
	if (!canOpenSetupWizardOnRoute(routeName)) {
		return 'close';
	}

	if (!deviceSupportsAutoOpen || deferredInSession) {
		return 'idle';
	}

	if (loggedIn && preferencesLoaded) {
		return 'openIfNeeded';
	}

	return 'idle';
};
